import { GetPlayerPropsParams } from '@pff-consumer/schema'

export const bettingEndpoints = {
  getPlayerProps: (params: GetPlayerPropsParams) => {
    const { league, season, weekAbbr, sportsbooks, propMarkets, positions, sortBy } = params
    return {
      url: `football/v2/betting/${league}/${season}/player-props/${weekAbbr}`,
      params: {
        sportsbooks,
        propMarkets,
        positions,
        sortBy,
      },
    }
  },
}
